angular.module('picmonicng').directive('learnFactTooltip', [
  '$sce',
  '$interval',
  '$timeout',
  'LearnService',
  'UserService',
  '$rootScope',
  function ($sce, $interval, $timeout, LearnService, UserService, $rootScope) {
    return {
      restrict: 'E',
      replace: true,
      templateUrl: '/templates/directives/learn-fact-tooltip.html',
      link: function (scope, element, attrs) {
        scope.$sce = $sce;
        scope.UserService = UserService;
        scope.editor = attrs.editor;

        var interval;

        scope.$on('learnAudioPlay', function () {
          if (scope.fact.selected) {
            $timeout(placeTooltip, 0);
          }
        });

        scope.$on('learnAudioPause', function () {
          if (scope.fact.selected) {
            $timeout(placeTooltip, 0);
          }
        });

        scope.$on('learnStepChange', function () {
          if (scope.fact.selected) {
            $timeout(placeTooltip, 0);
          }
        });

        scope.toggleDefinitionVisibility = function () {
          LearnService.toggleDefinitionVisibility();
          placeTooltip();
        };

        function placeTooltip() {
          element.addClass('size-check');

          scope.maxheight = element.find('.learn-fact-tooltip').height();

          element.removeClass('size-check');

          if (typeof scope.maxheight === 'undefined') {
            return;
          }

          element.removeClass(scope.class);
          var container = element.parents('.learn-image-wrapper');
          var tooltip = element;

          var container = {
            height: container.height(),
            width: container.width() + (LearnService.factsOpen ? 215 : 0),
          };

          if (LearnService.currentCard.has_characters || scope.editor) {
            scope.styles = {};
            scope.fact.tooltipStyles = {};

            var minx;
            var miny;
            var maxx;
            var maxy;
            var overflow;

            if (scope.fact.characters.length > 0) {
              for (a in scope.fact.characters) {
                var character = scope.fact.characters[a];

                minx =
                  typeof minx != 'undefined'
                    ? character.character_x + character.crop_x < minx
                      ? character.character_x + character.crop_x
                      : minx
                    : character.character_x + character.crop_x;
                miny =
                  typeof miny != 'undefined'
                    ? character.character_y + character.crop_y < miny
                      ? character.character_y + character.crop_y
                      : miny
                    : character.character_y + character.crop_y;
                maxx =
                  typeof maxx != 'undefined'
                    ? character.character_x + character.crop_x + character.crop_width > maxx
                      ? character.character_x + character.crop_x + character.crop_width
                      : maxx
                    : character.character_x + character.crop_x + character.crop_width;
                maxy =
                  typeof maxy != 'undefined'
                    ? character.character_y + character.crop_y + character.crop_height > maxy
                      ? character.character_y + character.crop_y + character.crop_height
                      : maxy
                    : character.character_y + character.crop_y + character.crop_height;
              }

              if (!minx && !miny) {
                minx = scope.fact.hotspot_x;
                maxx = scope.fact.hotspot_x + 260;
                miny = scope.fact.hotspot_y;
              }

              var left = minx / 2200 + (maxx - minx) / 2200;
              var top = miny / 1700;
            } else {
              var left = 0.42;
              var top = 0.55;
            }

            scope.class = '';

            // use specified placement if set
            if (scope.fact.tooltip_placement !== null) {
              switch (scope.fact.tooltip_placement) {
                case 0: //top-left
                  scope.fact.tooltipStyles.top = scope.styles.top = 16;
                  scope.fact.tooltipStyles.left = scope.styles.left = 16;
                  scope.fact.tooltipStyles.maxHeight = scope.styles.maxHeight = 'calc(100% - 16px)';
                  break;
                case 1: //top-right
                  scope.fact.tooltipStyles.top = scope.styles.top = 16;
                  scope.fact.tooltipStyles.right = scope.styles.right = 16;
                  scope.fact.tooltipStyles.maxHeight = scope.styles.maxHeight = 'calc(100% - 16px)';
                  break;
                case 2: //center-left
                  scope.fact.tooltipStyles.top = scope.styles.top = Math.max(
                    Math.min(container.height / 2 - 42, container.height - scope.maxheight),
                    0
                  );
                  scope.fact.tooltipStyles.left = scope.styles.left = container.width / 2 - 130;
                  break;
                case 3: //bottom-left
                  scope.fact.tooltipStyles.bottom = scope.styles.bottom = 16;
                  scope.fact.tooltipStyles.left = scope.styles.left = 16;
                  scope.fact.tooltipStyles.maxHeight = scope.styles.maxHeight = 'calc(100% - 16px)';
                  break;
                case 4: //bottom-right
                  scope.fact.tooltipStyles.bottom = scope.styles.bottom = 16;
                  scope.fact.tooltipStyles.right = scope.styles.right = 16;
                  scope.fact.tooltipStyles.maxHeight = scope.styles.maxHeight = 'calc(100% - 16px)';
                  break;
                case 5: //custom
                  scope.fact.tooltipStyles.top = scope.styles.top = (scope.fact.tooltip_y / 1700) * 100 + '%';
                  scope.fact.tooltipStyles.left = scope.styles.left = (scope.fact.tooltip_x / 2200) * 100 + '%';
                  scope.fact.tooltipStyles.maxHeight = scope.styles.maxHeight =
                    (1 - scope.fact.tooltip_y / 1700) * 100 + '%';
                  break;
              }

              // Determine if the tooltip can fit to the right of the character group's bounding box
            } else if (left * container.width + tooltip.width() < container.width) {
              scope.styles.left = left * 100 + '%';
              determineDefaultTop();

              // Determine if the tooltip can fit to the left of the character group's bounding box
            } else if ((minx / 2200) * container.width >= tooltip.width()) {
              scope.styles.left = 'calc(' + (minx / 2200) * 100 + '% - 260px)';
              scope.class = 'left';
              determineDefaultTop();

              // Determine if the tooltip can fit under the character group's bounding box
            } else if ((top + (maxy - miny) / 1700) * container.height + scope.maxheight < container.height) {
              scope.styles.left = (minx / 2200) * 100 + '%';
              scope.styles.top = top * 100 + ((maxy - miny) / 1700) * 100 + '%';
              scope.fact.tooltipStyles.top = scope.styles.top;

              // Determine if the tooltip can fit above the character group's bounding box
            } else if (top * container.height >= scope.maxheight) {
              scope.styles.left = (minx / 2200) * 100 + '%';
              scope.styles.bottom = 100 - top * 100 + '%';
              scope.class = 'top align-bottom';
              scope.fact.tooltipStyles.top = top * 100 + '%';

              // If all else fails, put the tooltip inside the character group's bounding box at the top left corner
            } else {
              determineDefaultTop();
            }

            scope.fact.tooltipStyles.left = scope.styles.left;

            function determineDefaultTop() {
              if (top * container.height + scope.maxheight > container.height) {
                overflow = Math.abs((container.height - (top * container.height + scope.maxheight)) / container.height);
              } else {
                overflow = 0;
              }

              scope.styles.top = ((top - overflow) * 100 > 0 ? (top - overflow) * 100 : 0) + '%';
              scope.fact.tooltipStyles.top = scope.styles.top;
            }
          } else {
            scope.styles = {
              height: scope.maxheight,
            };

            var left = scope.fact.hotbox_x / 2200 + scope.fact.hotbox_width / 2200; //Find the percentage value of the right side of the hotbox (the left value of the tooltip)
            var top = scope.fact.hotbox_y / 1700; //Find the percentage value of the top side of the hotbox (also the top value of the tooltip)
            //if the screen is wide enough to fit the hotbox and the tooltip inline
            if (left * container.width + tooltip.width() < container.width) {
              scope.styles.left = left * 100 + '%';
              scope.class = '';

              if (top * container.height + scope.maxheight < container.height) {
                scope.styles.top = top * 100 + '%';
              } else {
                scope.styles.top =
                  'calc(' +
                  (scope.fact.hotbox_y / 1700) * 100 +
                  '% - ' +
                  (scope.maxheight - (scope.fact.hotbox_height / 1700) * container.height) +
                  'px)';
                scope.class += ' align-bottom';
              }
            } else if ((scope.fact.hotbox_x / 2200) * container.width >= tooltip.width()) {
              scope.class = 'left';
              scope.styles.left = 'calc(' + (scope.fact.hotbox_x / 2200) * 100 + '% - ' + tooltip.width() + 'px)';

              if (top * container.height + scope.maxheight < container.height) {
                scope.styles.top = top * 100 + '%';
              } else {
                scope.styles.top =
                  'calc(' +
                  (scope.fact.hotbox_y / 1700) * 100 +
                  '% - ' +
                  (scope.maxheight - (scope.fact.hotbox_height / 1700) * container.height) +
                  'px)';
                scope.class += ' align-bottom';
              }
            } else if (
              (top + scope.fact.hotbox_height / 1700) * container.height + scope.maxheight <
              container.height
            ) {
              scope.styles.left = (scope.fact.hotbox_x / 2200) * 100 + '%';
              scope.styles.top = top * 100 + (scope.fact.hotbox_height / 1700) * 100 + '%';
              scope.class = 'bottom';
            } else if (top * container.height >= scope.maxheight + 15) {
              scope.styles.top = 'calc(' + top * 100 + '% - ' + (scope.maxheight + 15) + 'px)';
              scope.styles.left = (scope.fact.hotbox_x / 2200) * 100 + '%';
              scope.class = 'top align-bottom';
            } else {
              scope.styles.top = top * 100 + '%';
              scope.styles.left = (scope.fact.hotbox_x / 2200) * 100 + '%';
              scope.class = 'bottom';
            }
          }

          element.addClass(scope.class);
        }

        angular.element(window).resize(function () {
          placeTooltip();
          scope.$apply();
        });

        scope.$watch(
          function () {
            return scope.fact.selected || scope.fact.showHoverTooltip;
          },
          function () {
            if (scope.fact.selected || scope.fact.showHoverTooltip || scope.editor) {
              placeTooltip();
              scope.show = true;
            } else {
              scope.show = false;
            }
          }
        );

        scope.$watch(attrs.ngBindHtml, placeTooltip);

        placeTooltip();

        scope.playFactAudio = function () {
          LearnService.playFactAudio(scope.fact);
        };

        scope.selectQuizAnswer = function (answer) {
          answer.selected = true;
          LearnService.quizStep = 2;
          if (answer.name == scope.fact.name) {
            LearnService.quizAnswer('y');

            scope.time_remaining = 3;

            interval = $interval(function () {
              scope.time_remaining -= 1;

              if (scope.time_remaining == 0) {
                scope.nextFact();
              }
            }, 1000);
          } else {
            LearnService.quizAnswer('n');
          }
        };

        scope.nextFact = function () {
          if (interval) {
            $interval.cancel(interval);
            scope.time_remaining = null;
          }
          LearnService.nextFact();
        };

        if (scope.editor) {
          scope.$watch('fact.tooltip_placement', placeTooltip);
          var initX, initY, offset;

          function onMouseMove(e) {
            element[0].style.left = e.clientX - offset.left - initX + 'px';
            element[0].style.top = e.clientY - offset.top - initY + 'px';
          }

          element.on('mousedown', function (e) {
            var init = element.offset();
            offset = angular.element('.learn-image-wrapper').offset();

            initX = e.clientX - init.left;
            initY = e.clientY - init.top;

            angular.element('body').on('mousemove', onMouseMove);
          });
          element.on('mouseup', function (e) {
            angular.element('body').off('mousemove', onMouseMove);
            var wrapper = angular.element('.learn-image-wrapper');
            scope.$apply(function () {
              scope.styles.left = e.clientX - offset.left - initX + 'px';
              scope.styles.top = e.clientY - offset.top - initY + 'px';
              scope.fact.tooltip_placement = 5;
              scope.fact.tooltip_x = ((e.clientX - offset.left - initX) / wrapper.width()) * 2200;
              scope.fact.tooltip_y = ((e.clientY - offset.top - initY) / wrapper.height()) * 1700;
            });
          });
        }
      },
    };
  },
]);
